// extracted by mini-css-extract-plugin
module.exports = {"panel":"style__panel__HsLbC","header":"style__header__toV-2"};